/* src/app/components/pages/application/application.component.scss */
.headerClass {
  background-color: var(--theme-deafult);
  color: var(--theme-deafult-text);
  padding: 10px 20px;
}
.m-bb-10 {
  margin-bottom: 10px;
}
#preventIphoneselect input {
  -webkit-touch-callout: none;
}
.m-ll-25 {
  margin-left: 25px;
}
.thinkpolicy {
  text-decoration: none;
}
.thinkpolicy:hover {
  text-decoration: none;
}
.mat-badge-content {
  background-color: var(--theme-deafult-secondary) !important;
}
.margin-img {
  margin: 0px !important;
}
.width-img {
  width: 60px !important;
}
#application .custom-errors {
  color: red;
  font-size: 12px;
  margin-top: -20px;
}
#application .has-errors {
  position: absolute !important;
  margin: 0px !important;
  padding: 0 !important;
  top: 45px !important;
  left: 5px !important;
  margin-top: 3px !important;
  font-size: 12px !important;
  margin-left: -10px !important;
}
#application {
  background-color: #EBEBEB;
}
#application .main {
  max-width: 1110px;
  margin: auto;
  padding: 16px;
}
@media only screen and (min-width: 1200px) {
  #application .main .firstContent {
    padding: 36px 36px 20px 0;
  }
}
#application .main .firstContent .headerLogo .avtar {
  border-radius: 50%;
  width: 45px;
  height: 45px;
}
#application .main .firstContent .companyLabel {
  color: #4E4E5A;
  font-size: 10px;
  font-family: "IBM Plex Sans", sans-serif;
  font-style: sans-serif;
}
#application .main .firstContent .companyName {
  color: #333333;
  font-size: 13px;
  font-weight: 500px !important;
  font-family: "IBM Plex Sans", sans-serif;
  font-style: sans-serif;
}
#application .main .firstContent .borderLeft {
  border-left: 1px solid #000;
  height: 20px;
}
#application .main .firstContent .flag-icon {
  width: 20px;
  height: 15px;
  margin-right: 10px;
}
#application .main .firstContent .taxBox {
  color: #51c1e8;
  cursor: pointer;
}
#application .main .firstContent .f-s-12-m-0 {
  font-size: 12px !important;
  margin: 0 !important;
}
@media only screen and (max-width: 600px) {
  #application .main .firstContent .mat-expansion-panel-header {
    padding: 10px 10px !important;
  }
  #application .main .firstContent .mat-expansion-panel-header .mat-icon {
    color: #3b4e60;
    font-size: 24px;
    width: 24px;
    height: 24px;
    padding-right: 12px;
  }
  #application .main .firstContent .mat-expansion-panel-header .editIcon .mat-icon {
    padding-right: 0px;
  }
  #application .main .firstContent .m-top-25 {
    margin-top: 25px !important;
  }
  #application .main .firstContent .p-left-15 {
    padding-left: 15px !important;
  }
}
@media only screen and (min-width: 600px) {
  #application .main .firstContent .m-l-b {
    margin: 0px 0px 10px 19px;
  }
}
#application .main .firstContent .mat-expansion-panel .mat-expansion-panel-header {
  padding: 0px 10px;
}
#application .main .firstContent .mat-expansion-panel .mat-expansion-panel-header .mat-icon {
  color: #3b4e60;
  font-size: 24px;
  width: 24px;
  height: 24px;
  padding-right: 12px;
}
#application .main .firstContent .mat-expansion-panel .mat-expansion-panel-header .editIcon .mat-icon {
  padding-right: 0px;
}
#application .main .firstContent .samSpaceButton .mat-mdc-button {
  padding: 0px 8px 0px 16px;
}
#application .main .secondContent .mat-mdc-card {
  padding: 5px 24px 0px 4px;
}
#application .main .secondContent .orderSummary {
  color: #3B4E60;
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 15px !important;
  font-weight: 700;
}
#application .main .secondContent .itemCount {
  color: #3b4e60;
  font-size: 12px !important;
  letter-spacing: 0;
  opacity: 0.54;
}
#application .main .secondContent .items {
  padding-left: 5px;
  padding-bottom: 15px;
  margin-top: 15px !important;
}
#application .main .secondContent .items .cart-items__images {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 90px;
  overflow: hidden;
  margin-right: 15px;
  flex: 0 0 90px;
}
#application .main .secondContent .items .cart-items__images img {
  border-radius: 0;
  width: 100%;
  height: auto;
  margin: 0;
  flex-shrink: 0;
}
#application .main .secondContent .items .md-avatar:first-child,
#application .main .secondContent .items .-inner > .md-avatar:first-child {
  border-radius: 0;
  width: 90px;
  height: 90px;
}
#application .main .secondContent .items .md-secondary-container {
  top: 87%;
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
  margin-bottom: 10px;
}
#application .main .secondContent .items .input-group {
  width: 88px;
  line-height: 0;
}
#application .main .secondContent .items .input-group .input-group-btn button {
  background: #fff;
  border: 1px solid #ccc;
  width: 30px;
  height: 30px;
  box-shadow: none;
}
#application .main .secondContent .items .input-group .input-control {
  background: #fff;
  border: 1px solid #ccc;
  width: 30px;
  height: 28px;
  text-align: center;
  color: var(--theme-sidebar-selected);
}
#application .main .secondContent .items .md-button.remove-items {
  position: absolute;
  top: -10px;
  right: 0;
}
#application .main .secondContent .items mat-divider {
  left: 50px;
  bottom: -1px;
}
#application .main .secondContent .mat-expansion-panel {
  box-shadow: none;
}
#application .main .secondContent .mat-expansion-panel-header {
  padding: 0px 0px 0px 24px;
}
#application .main .pdfcontent .orderSummary {
  color: #3B4E60;
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 15px !important;
  font-weight: 700;
}
#application .main .pdfcontent a {
  text-decoration: none;
  color: var(--theme-deafult-secondary);
}
#application .main .pdfcontent a:hover {
  text-decoration: none;
  color: var(--theme-deafult-secondary);
}
@media screen and (min-width: 1300px) {
  #application .main .pdfcontent .mat-mdc-card {
    padding: 16px 16px 16px 4px;
  }
}
@media screen and (min-width: 1300px) {
  #application .main .pdfcontent .mat-mdc-card {
    padding: 5px 14px 5px 4px;
    width: 330px;
  }
}
#application .main .headingTitle-f-s-30 {
  font-family: "IBM Plex Sans", sans-serif;
  font-weight: bold;
  font-size: 30px;
  font-style: italic;
  margin: 0;
  letter-spacing: -0.75px;
  color: #3B4E60;
}
#application .main .subTitle-f-s-16 {
  font-family: "IBM Plex Sans", sans-serif;
  font-weight: bold;
  font-size: 16px;
  font-style: italic;
  margin: 0;
  color: #3B4E60;
}
#application .main .borderBottom {
  border-bottom: 1px solid #cfcfcf;
}
#application .main .borderTop {
  border-top: 1px solid #cfcfcf;
}
#application .main .m-t-b-15 {
  margin: 15px 0px;
}
#application .main .m-t-b-40-15 {
  margin: 15px 40px;
}
#application .addButton button {
  color: #3b4e60;
  text-align: center !important;
  border: 1px solid #3b4e60;
  background: #fff 0 0 no-repeat padding-box;
  height: 36px;
}
#application .color-f-s-15 {
  color: #3b4e60;
  font-size: 21px;
  font-family: "IBM Plex Sans", sans-serif;
}
#application .color-f-s-13 {
  color: #3b4e60;
  font-size: 13px;
  font-family: "IBM Plex Sans", sans-serif;
}
#application .color-f-s-12 {
  color: #3b4e60;
  font-size: 12px;
  font-family: "IBM Plex Sans", sans-serif;
}
#application .color-f-s-11 {
  color: #3b4e60;
  font-size: 11px;
  font-family: Helvetica;
  margin: 0px 13px 0px 0px;
}
#application .color2-f-s-12 {
  color: #3A4D5F;
  font-size: 16px;
  font-family: "IBM Plex Sans", sans-serif;
  text-align: justify;
  line-height: 1.3;
  margin: 0px;
}
#application .color-f-s-13 {
  color: black;
  font-size: 13px;
  font-family: "IBM Plex Sans", sans-serif;
  line-height: 1.3;
  margin: 12px 0 0 0 !important;
}
#application .color3-f-s-13 {
  color: var(--theme-sidebar-selected);
  font-size: 13px;
  font-family: "IBM Plex Sans", sans-serif;
}
#application .color-f-s-24 .mat-icon {
  color: #3b4e60;
  font-size: 24px;
  font-family: "IBM Plex Sans", sans-serif;
}
#application .p-t-9 {
  padding-top: 9px !important;
}
#application .mat-icon {
  cursor: pointer;
}
#application .p-t-b-7 {
  padding: 7px 0px 7px 0px !important;
}
#application .m-l-48 {
  margin-left: 48px !important;
}
#application .product_detail_text1 {
  font-size: 13px !important;
  margin: 0 !important;
  line-height: 18px !important;
}
@media only screen and (min-width: 1200px) {
  #application .m-top2-25 {
    padding-top: 25px !important;
  }
}
#application .coupon_error {
  top: 44px;
  position: absolute;
}
.firstcard .enroll_info {
  margin-left: 10px;
}
.term_condition {
  min-height: 40px;
  height: auto;
  margin: 10px 0px;
}
#application .mat-mdc-standard-chip .mat-chip-remove.mat-icon,
.mat-standard-chip .mat-chip-remove .mat-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
}
#application mat-form-field {
  font-family: "IBM Plex Sans", sans-serif !important;
}
.logo {
  letter-spacing: normal;
  font-size: 24px;
  font-weight: 700;
  font-family: "IBM Plex Sans", sans-serif;
}
#sideCartBox {
  position: fixed;
  right: 25px;
  top: 100px;
  bottom: inherit;
  left: inherit;
  max-height: 610px;
  box-shadow:
    0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
.full-sideCartBox-height {
  max-height: 100% !important;
}
#sideCartBox {
  overflow-y: auto;
  overflow-x: hidden;
}
.policyblock {
  margin-left: -50px !important;
  margin-top: 10px !important;
}
.cards-available {
  margin-top: 5px !important;
}
.gap-between {
  border: 2px solid #ebebeb !important;
  border-radius: 5px !important;
  margin-left: -65px !important;
  margin-right: -65px !important;
}
#sideCartBox::-webkit-scrollbar {
  width: 4px;
}
#sideCartBox::-webkit-scrollbar-thumb {
  background: var(--theme-deafult-secondary);
  border-radius: 10px;
}
#sideCartBox::-webkit-scrollbar-track {
  background: #eeeeee;
}
@media screen and (max-width: 1300px) {
  #sideCartBox {
    position: initial !important;
  }
  #pdfcontentBox {
    position: initial !important;
  }
}
/*# sourceMappingURL=application.component.css.map */
